import Vue from 'vue';
import Router from 'vue-router';
import store from "@/store";

import LoginView from '@/views/LoginView.vue';
import PageView from '@/views/PageView.vue';
import GeneralEntryView from '@/views/GeneralEntryView.vue';

import {
    AUTHENTICATION_LOGOUT_NS,
} from "@/store/actions.type";

Vue.use(Router)

const router = new Router({
    mode: 'hash',
    base: window.siteHandle,
    routes: [
        {
            path: '/',
            name: 'home',
            component: PageView,
            meta: {
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: LoginView
        },
        {
            path: '/logout',
            name: 'logout',
            beforeEnter: async (to, from, next) => {
                await store.dispatch(AUTHENTICATION_LOGOUT_NS);
                return next('/login');
            }
        },
        {
            path: '/impressum',
            name: 'imprint',
            component: GeneralEntryView,
            meta: {
                requiresAuth: false,
                slug: 'impressum'
            }
        },
        {
            path: '/datenschutzrichtlinien',
            name: 'privacy',
            component: GeneralEntryView,
            meta: {
                requiresAuth: false,
                slug: 'datenschutzrichtlinien'
            }
        },
        {
            path: '/compliance',
            name: 'compliance',
            component: GeneralEntryView,
            meta: {
                requiresAuth: false,
                slug: 'compliance'
            }
        },
        {
            path: '/:slug',
            name: 'entry',
            props: true,
            component: GeneralEntryView,
            meta: {
                requiresAuth: true
            }
        }
    ]
});

router.beforeEach(async (to, from, next) => {

    if(to.matched.some(record => record.meta.requiresAuth)) {
        if (!store.getters['authentication/isLoggedIn']) {
            return next('/login');
        }
    }

    return next();
});

export default router;
